import React, { useState } from "react";
import { axInst } from "../Login/Service";
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
} from "@tanstack/react-table";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { useSelector } from "react-redux";
import WaterMark from "../WaterMark/WaterMark";
import Complaint_Details_Modal from "./Complaint_Detail";

const table_details = async (body, endpoint) => {
  // console.log(endpoint);
  try {
    const res = await axInst.post(endpoint, body);
    const data = res.data.Data_Fetch;

    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const Modal = ({ closeModal, Modaldata }) => {
  const { data, submitted } = useSelector((state) => state.filtersComplaint);
  const [sorting, setSorting] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [pageIndex, setPageIndex] = useState(0);

  const [detailData, setDetailData] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  const endpointMap = {
    0: "complaints/sla_breach_1day",
    1: "complaints/sla_breach_3day",
    2: "complaints/sla_breach_5day",
  };

  const endpoint = endpointMap[Modaldata.seriesIndex];

  const {
    data: tabledata,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["Tabledetailed", submitted],
    queryFn: () => table_details(data, endpoint),
    initialData: [],
    cacheTime: 0,
    staleTime: 0,
  });

  // Define table columns
  const columns = [
    {
      header: "Date",
      accessorFn: (row) => row.OPEN_DATE,
    },
    {
      header: "Origin",
      accessorFn: (row) => row.X_ATTRIB_04,
    },
    {
      header: "Primary Clt Area",
      accessorFn: (row) => row.AREA,
    },
    {
      header: "Sub Area",
      accessorFn: (row) => row.SUB_AREA,
    },
    {
      header: "Open For Days",
      accessorFn: (row) => row.OPEN_FOR_DAYS,
    },
    {
      header: "Complt #",
      accessorFn: (row) => row.SR_NUM,
      cell: ({ row }) => (
        <span
          className="text-blue-500 cursor-pointer"
          onClick={() => {
            setDetailData(row.original.SR_NUM);
            setIsDetailModalOpen(true);
          }}
        >
          {row.original.SR_NUM}
        </span>
      ),
    },
  ];

  // Initialize table
  const table = useReactTable({
    data: tabledata,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      sorting,
      globalFilter,
    },
    initialState: {
      pagination: {
        pageIndex,
        pageSize: 8,
      },
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter, // Updated to handle global filter
  });

  const goToPage = (index) => {
    setPageIndex(index);
    table.setPageIndex(index);
  };

  return (
    <div className="modal-overlay">
      <div className="modal relative md:w-[800px] w-full">
        <div className="flex justify-center font-bold items-center">
          <h2>SLA Breach Alert Details</h2>
        </div>
        <button
          onClick={closeModal}
          className="close-button absolute right-6 top-0"
        >
          &times;
        </button>
        <div className="flex-auto mt-2">
          <div className="self-center overflow-auto lg:h-96 h-72">
            {isError && (
              <div className="grid items-center justify-center w-full h-full">
                <p>Error Occurred</p>
              </div>
            )}
            {isFetching && (
              <div className="grid items-center justify-center w-full h-full">
                <Loader size="lg" />
              </div>
            )}
            <WaterMark />
            {!isFetching && !isError && (
              <>
                {tabledata && tabledata.length > 0 ? (
                  <>
                    <div className="flex justify-end">
                      <input
                        type="text"
                        value={globalFilter}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="p-1 mb-2 border rounded text-[12px]"
                      />
                    </div>
                    <table className="w-full text-left">
                      <thead className="sticky text-white top-0  bg-[#2A5775]">
                        {table.getHeaderGroups().map((headerGroup) => (
                          <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => (
                              <th
                                key={header.id}
                                className="py-4 px-0.5 text-xs font-normal lg:px-1 lg:font-medium lg:text-sm border-1 whitespace-nowrap"
                              >
                                {header.isPlaceholder
                                  ? null
                                  : flexRender(
                                      header.column.columnDef.header,
                                      header.getContext()
                                    )}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody>
                        {table.getRowModel().rows.map((row) => (
                          <tr
                            key={row.id}
                            className="even:bg-gray-200 odd:bg-white"
                          >
                            {row.getVisibleCells().map((cell) => (
                              <td
                                key={cell.id}
                                className="p-[2px] whitespace-nowrap text-xs lg:text-sm border-1 h-8"
                              >
                                {flexRender(
                                  cell.column.columnDef.cell,
                                  cell.getContext()
                                )}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                ) : (
                  <div className="grid items-center justify-center w-full h-full">
                    <p>Data is not available.</p>
                  </div>
                )}
              </>
            )}
          </div>

          <div className="flex py-2 justify-evenly">
            <button
              onClick={() => {
                const prevIndex = pageIndex - 1;
                if (prevIndex >= 0) {
                  setPageIndex(prevIndex);
                  table.setPageIndex(prevIndex);
                }
              }}
              disabled={!table.getCanPreviousPage()}
            >
              {"⬅️"} Previous Page
            </button>

            <div className="flex self-center gap-2">
              <span>Go to page :</span>
              <input
                type="number"
                max={table.getPageCount()}
                min={1}
                value={pageIndex + 1}
                onChange={(e) => {
                  const page = parseInt(e.target.value, 10);
                  if (!isNaN(page)) {
                    goToPage(page - 1);
                  }
                }}
                className="w-12 text-center border rounded"
              />
              <span>of {table.getPageCount()}</span>
            </div>

            <button
              onClick={() => {
                const nextIndex = pageIndex + 1;
                if (table.getCanNextPage()) {
                  setPageIndex(nextIndex);
                  table.setPageIndex(nextIndex);
                }
              }}
              disabled={!table.getCanNextPage()}
            >
              Next page {"➡️"}
            </button>
          </div>
        </div>
      </div>
      {isDetailModalOpen && (
        <Complaint_Details_Modal
          closeModal={() => setIsDetailModalOpen(false)}
          srNo={detailData}
        />
      )}
    </div>
  );
};
